import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { getPrimeNgTranslations } from '~shared/primeNG/prime-translation.helper';
import { PRIME_TRANSLATIONS_KEYS } from '~shared/primeNG/translation.consant';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    private readonly translateService = inject(TranslateService);
    private readonly primengConfig = inject(PrimeNG);

    constructor() {
        this.initLocale();
        this.setPrimeNgLocale();
    }

    private initLocale() {
        const locale: string = localStorage.getItem('locale') ?? 'da-DK';
        this.translateService.use(locale);
    }

    private setPrimeNgLocale() {
        this.translateService.stream(PRIME_TRANSLATIONS_KEYS).subscribe((res: Record<string, string>): void => {
            const translation = getPrimeNgTranslations(res);
            this.primengConfig.setTranslation(translation);
        });
    }
}
